import React from 'react';
import { Container } from '@mui/material';
import { AuditionWrapper, IAuditionWrapper } from '../../AuditionComponents/AuditionWrapper';

interface IAuditionContainerProps extends IAuditionWrapper {}

const AuditionContainer: React.FC<IAuditionContainerProps> = props => {
    return (
        <Container
            disableGutters
            maxWidth={false}
            style={{
                height: 'auto',
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                // overflow: 'hidden',
            }}
            sx={{
                width: '100%',
                marginTop: { xs: '0', sm: '20px' },
                marginLeft: { xs: '0px', sm: '0px', md: '40px', xl: '100px' },
                paddingLeft: { xs: '0px', sm: '40px', md: '0px' },
                paddingRight: { xs: '0px', sm: '0px', md: '0px', xl: '100px' },
                paddingTop: { xs: '20px', sm: '0px' },
                overflowX: 'hidden',
            }}>
            <AuditionWrapper {...props} />
        </Container>
    );
};

export { AuditionContainer };
